import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function TrustedContactsCell({ trustedContacts, userName }) {
  const navigate = useNavigate();

  if (!trustedContacts) {
    return <span style={{ color: '#94A3B8', fontSize: 12 }}>0 contacts</span>;
  }

  const { label, detailPath } = trustedContacts;

  if (!detailPath) {
    return <span style={{ color: '#94A3B8', fontSize: 12 }}>{label || '0 contacts'}</span>;
  }

  return (
    <button
      type="button"
      title={userName ? `View trusted contacts for ${userName}` : 'View trusted contacts'}
      onClick={(e) => {
        e.stopPropagation();
        navigate(detailPath);
      }}
      style={{
        background: 'none',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        color: '#1D4ED8',
        fontSize: 12,
        fontWeight: 600,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
      }}
    >
      <i className="fas fa-user-group" style={{ fontSize: 10 }} />
      {label}
    </button>
  );
}
